import React, { useEffect, useState } from "react";
// assets and scss import ==>
import "./customToggleButton.scss";
// constant import ==>

const CustomToggleButton = (props) => {
  const { title, selected, deselectedLabel, selectedLabel, handleOnClick } =
    props;

  return (
    <div className="custom-toggle-button-container">
      {title && <div className="ctbc-title">{title}</div>}
      <div
        className={"ctbc-content " + (selected ? "ctbc-content-selected" : "")}
        onClick={handleOnClick}
      >
        <div
          className={
            "ctbc-toggle-btn " + (selected ? "ctbc-toggle-btn-selected" : "")
          }
        ></div>
        {selected ? (
          <div className="ctbc-selected-label">{selectedLabel}</div>
        ) : (
          <div className="ctbc-deselected-label">{deselectedLabel}</div>
        )}
      </div>
    </div>
  );
};

export default CustomToggleButton;
